module.exports = __webpack_public_path__ + "media/images/figure/market-4adc8dcf0a387f4e3094aedf7e7109bb.jpg";